const es = {
    dayNamesShort: [
        'Dom',
        'Lun',
        'Mar',
        'Mie',
        'Jue',
        'Vie',
        'Sab'
    ],
    dayNames: [
        'Domingo',
        'Lunes',
        'Martes',
        'Miércoles',
        'Jueves',
        'Viernes',
        'Sábado'
    ],
    monthNamesShort: [
        'Ene',
        'Feb',
        'Mar',
        'Abr',
        'May',
        'Jun',
        'Jul',
        'Ago',
        'Sep',
        'Oct',
        'Nov',
        'Dic'
    ],
    monthNames: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
    ],
    amPm: [
        'am',
        'pm'
    ],
    DoFn: (day)=>`${day}°`
};
const humanized = {
    SECONDS_AGO: 'Hace un momento',
    A_MINUTE_AGO: 'Hace un minuto',
    MINUTES_AGO: (mins)=>`Hace ${mins} minutos`,
    AN_HOUR_AGO: 'Hace una hora',
    HOURS_AGO: (hours)=>`Hace ${hours} horas`,
    A_DAY_AGO: 'Hace un día',
    DAYS_AGO: (days)=>`Hace ${days} días`,
    A_MONTH_AGO: 'Hace un mes',
    MONTHS_AGO: (months)=>`Hace ${months} meses`,
    A_YEAR_AGO: 'Hace un año',
    YEARS_AGO: (years)=>`Hace ${years} años`
};
const remaining = {
    SECONDS_AGO: 'un momento',
    A_MINUTE_AGO: 'un minuto',
    MINUTES_AGO: (mins)=>`${mins} minutos`,
    AN_HOUR_AGO: 'una hora',
    HOURS_AGO: (hours)=>`${hours} horas`,
    A_DAY_AGO: 'un día',
    DAYS_AGO: (days)=>`${days} días`,
    A_MONTH_AGO: 'un mes',
    MONTHS_AGO: (months)=>`${months} meses`,
    A_YEAR_AGO: 'un año',
    YEARS_AGO: (years)=>`${years} años`
};
const locales_es = es;
export default locales_es;
export { humanized, remaining };
